const initCookies = () => {
  const cookies = document.querySelector("[data-cookies]");
  if (!cookies) return;
    
  const trackScroll = () => {
    window.scrollY > 300
      ? cookies.style.opacity = "1"
      : cookies.style.opacity = "0";
  };
  
  trackScroll();
  window.addEventListener("scroll", trackScroll);

  /* Скрытие виджета cookie */
  const btn = document.querySelector("[data-cookies-btn]");

  btn.addEventListener('click', () => {
    localStorage.setItem('cookies-widget', true);
    cookies.style.display = "none";
  })

  if (localStorage.getItem('cookies-widget') !== null) {
    cookies.style.display = "none";
  }
};

export default initCookies;
